/* eslint-disable camelcase */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { validateReduxCache } from '../../../../../utils/cache.util';
import PAYMENT_CONSTANTS from '../Payment.constants';
import {
  setCardList,
  setGiftCardList,
  getCardListErr,
  showLoader,
  paymentAddGiftCardSuccess,
  setModuleX,
  getAddressAndCardListActionTriggeredThroughSPC,
} from './Payment.actions';
import { resetShowNotification } from '../AddGiftCard/container/AddGiftCard.actions';
import { getOnAddGiftCardPageState } from '../AddGiftCard/container/AddGiftCard.selector';
import { getModuleX } from '../../../../../services/abstractors/common/moduleX';
import {
  getGiftCardListApi,
  getAddressAndCardListApi,
} from '../../../../../services/abstractors/account/GetGiftCards';
import { getAddressList } from '../../AddressBook/container/AddressBook.saga';

export function* getCardList(props) {
  try {
    yield put(showLoader());
    const res = !props?.fromAccount ? yield call(getGiftCardListApi) : props.responsePayment;
    const isFromAddGiftCard = yield select(getOnAddGiftCardPageState);
    const cardList = [];

    if (res?.data) {
      const getAllPaymentCards = res.data?.getCustomer?.paymentInstruments
        ?.map((value) => {
          let giftCard;
          if (value.paymentMethodId === 'GIFT_CERTIFICATE') {
            giftCard = {
              accountNo: value.maskedGiftCertificateCode,
              ccBrand: 'GC',
              ccType: 'GiftCard',
              creditCardId: value?.paymentInstrumentId,
            };
          } else {
            const cardAddress = res.data?.getCustomer?.addresses?.filter((address) => {
              return address.addressId === value?.c_addressId;
            });
            let addressDetails = {};
            if (cardAddress.length) {
              addressDetails = {
                firstName: cardAddress[0]?.firstName,
                lastName: cardAddress[0]?.lastName,
                country: cardAddress[0]?.countryCode,
                addressLine1: cardAddress[0]?.address1?.trim(),
                addressLine2: cardAddress[0]?.address2?.trim(),
                city: cardAddress[0]?.city,
                state: cardAddress[0]?.stateCode,
                zipCode: cardAddress[0]?.postalCode,
              };

              cardList.push({
                accountNo: value?.paymentCard?.maskedNumber,
                billingAddressId: value?.c_addressId,
                ccType: value?.paymentCard?.cardType,
                creditCardId: value?.paymentInstrumentId,
                defaultInd:
                  res.data?.getCustomer?.paymentInstrumentId === value?.paymentInstrumentId,
                expMonth: value?.paymentCard?.expirationMonth.toString(),
                expYear: value?.paymentCard?.expirationYear.toString(),
                nameOnAccount: value?.paymentCard?.holder,
                addressDetails,
                paymentMethodId: value?.paymentMethodId,
                addressId: value?.c_addressId,
              });
            }
          }
          return giftCard;
        })
        .filter((anyValue) => typeof anyValue !== 'undefined');
      yield put(setCardList(cardList || []));
      yield put(setGiftCardList(getAllPaymentCards || []));
      if (isFromAddGiftCard) {
        yield put(paymentAddGiftCardSuccess());
        yield put(resetShowNotification());
      }
      return yield;
    }
    return yield put(getCardListErr(res?.error));
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'Payment Saga - getCardList',
      },
    });
    return yield put(getCardListErr(err));
  }
}

export function* getAddressAndCardListSaga() {
  try {
    yield put(showLoader());
    const res = yield call(getAddressAndCardListApi);
    yield call(getCardList, { responsePayment: res?.responsePayment, fromAccount: true });
    yield call(getAddressList, {
      responseAddress: res?.responseAddress,
      fromAccount: true,
    });
    yield put(getAddressAndCardListActionTriggeredThroughSPC(true));
    return yield;
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'Payment Saga - getAddressAndCardListSaga',
      },
    });
    return yield put(getCardListErr(err));
  }
}

export function* fetchModuleX({ payload = '' }) {
  try {
    const result = yield call(getModuleX, payload);
    yield put(setModuleX(result));
  } catch (err) {
    yield null;
  }
}

export function* PaymentSaga() {
  const cachedCardList = validateReduxCache(getCardList);
  const cachedGetAddressAndCardListSaga = validateReduxCache(getAddressAndCardListSaga);
  yield takeLatest(PAYMENT_CONSTANTS.GET_CARD_LIST, cachedCardList);
  yield takeLatest(PAYMENT_CONSTANTS.GET_ADDRESS_AND_CARD_LIST, cachedGetAddressAndCardListSaga);
  yield takeLatest(PAYMENT_CONSTANTS.FETCH_MODULEX_CONTENT, fetchModuleX);
}

export default PaymentSaga;
